import React from 'react';
import styled from 'styled-components';

const OuterBox = styled.div.attrs({ className: 'OuterBox' })`
  display: flex;
  justify-content: center;
  /* background: red; */
`;

const outerBox = props => {
  return <OuterBox className={props.className}>{props.children}</OuterBox>;
};

export default outerBox;
